import { render, staticRenderFns } from "./DialogCmp.vue?vue&type=template&id=354886f4"
import script from "./DialogCmp.vue?vue&type=script&lang=js"
export * from "./DialogCmp.vue?vue&type=script&lang=js"
import style0 from "./DialogCmp.vue?vue&type=style&index=0&id=354886f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports